import axios from 'axios'
import { baseUrl } from '@/api/config'
import {errorCollection} from "@/api/dmp/dmpCollection";

/**
 * 查询当前租户aksk
 */
export function findSecret(params) {
  const url = baseUrl + '/secret/find'
  return axios({
    method: 'get',
    url: url,
    params: params
  }).then(res => {
    if (res.status !== 200 || !!res.data && res.data.state !== 0) {
      errorCollection('API密钥管理', '查询当前租户aksk', res)
    }
    return Promise.resolve(res.data)
  })
}

/**
 * 查询当前用户aksk
 */
export function findUserSecret(params) {
  const url = baseUrl + '/secret/owner'
  return axios({
    method: 'get',
    url: url,
    params: params
  }).then(res => {
    if (res.status !== 200 || !!res.data && res.data.state !== 0) {
      errorCollection('API密钥管理', '查询当前用户aksk', res)
    }
    return Promise.resolve(res.data)
  })
}

/**
 * 添加密钥
 */
export function addSecret() {
  const url = baseUrl + '/secret/add'
  return axios({
    method: 'post',
    url: url
  }).then(res => {
    if (res.status !== 200 || !!res.data && res.data.state !== 0) {
      errorCollection('API密钥管理', '添加密钥', res)
    }
    return Promise.resolve(res.data)
  })
}

/**
 * 根据用户ID分页查询图片记录
 */
export function enableSecret(id) {
  const url = baseUrl + '/secret/enable/' + id

  return axios({
    method: 'put',
    url: url
  }).then(res => {
    if (res.status !== 200 || !!res.data && res.data.state !== 0) {
      errorCollection('API密钥管理', '启用密钥', res)
    }
    return Promise.resolve(res.data)
  })
}
/**
 * 根据用户ID分页查询视频录制记录
 */
export function disableSecret(id) {
  const url = baseUrl + '/secret/disable/' + id
  return axios({
    method: 'put',
    url: url
  }).then(res => {
    if (res.status !== 200 || !!res.data && res.data.state !== 0) {
      errorCollection('API密钥管理', '禁用密钥', res)
    }
    return Promise.resolve(res.data)
  })
}

